// Genera beeps usando Web Audio API en lugar de cargar archivos MP3.
// Mas ligero, sin assets binarios y respeta las politicas de autoplay.

let audioContext = null
let muteState = false

export const setMuted = (muted) => {
  muteState = muted
}

export const isMuted = () => muteState

export const inicializarAudio = () => {
  try {
    if (!audioContext) {
      const AudioCtx = window.AudioContext || window.webkitAudioContext
      if (!AudioCtx) return
      audioContext = new AudioCtx()
    }
    // En algunos navegadores el contexto queda en 'suspended' aunque el
    // usuario haya hecho click. Hay que resumirlo explicitamente.
    if (audioContext.state === 'suspended') {
      audioContext.resume().catch((e) => console.warn('No se pudo resumir AudioContext:', e))
    }
  } catch (e) {
    console.warn('No se pudo crear AudioContext:', e)
  }
}

const beep = (frequency, durationMs, opts = {}) => {
  if (muteState || !audioContext) return
  try {
    // Defensiva: si el contexto se suspendio entre llamadas, resumelo
    if (audioContext.state === 'suspended') {
      audioContext.resume().catch(() => {})
    }

    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()

    oscillator.type = opts.waveform || 'sine'
    oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime)

    const volume = opts.volume ?? 0.3
    gainNode.gain.setValueAtTime(volume, audioContext.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + durationMs / 1000)

    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)

    oscillator.start(audioContext.currentTime)
    oscillator.stop(audioContext.currentTime + durationMs / 1000)
  } catch (e) {
    console.warn('Audio beep error:', e)
  }
}

// Encadena varios beeps con offset (para melodias)
const beepChain = (notes) => {
  if (muteState || !audioContext) return
  if (audioContext.state === 'suspended') {
    audioContext.resume().catch(() => {})
  }
  let offset = 0
  for (const note of notes) {
    setTimeout(() => beep(note.freq, note.duration, { volume: note.volume }), offset)
    offset += (note.gap ?? note.duration)
  }
}

export const alertaCambioSeccion = () => {
  // Beep grave largo
  beep(440, 250)
  if (navigator.vibrate) {
    navigator.vibrate(200)
  }
}

export const alertaAviso10seg = () => {
  // Beep agudo corto
  beep(880, 150)
  if (navigator.vibrate) {
    navigator.vibrate([100, 50, 100])
  }
}

export const alertaTermino = () => {
  // Melodia ascendente 'ya terminamos': do - mi - sol - do alto
  beepChain([
    { freq: 523, duration: 150, gap: 160 },  // C5
    { freq: 659, duration: 150, gap: 160 },  // E5
    { freq: 784, duration: 150, gap: 160 },  // G5
    { freq: 1047, duration: 350, gap: 350 }, // C6 (sostenido)
  ])
  if (navigator.vibrate) {
    navigator.vibrate([200, 100, 200, 100, 400])
  }
}
